import React, { useState, useEffect } from 'react'
import EditClientStep from './EditClientStep';
import ShowClientStep from './ShowClientStep';
import NextStep from './NextStep';
import { useTutorialContext } from '../TutorialProvider';

export default function Step1({ tutorialStep1 }) {
  const [loader, setLoader] = useState(false)
  const { run, stepIndex, tourCompleted, type } = tutorialStep1
  const [isExpand, setIsExpand] = useState(false)
  const { setTutorialStep1, setTutorialStep2 } = useTutorialContext()

  useEffect(() => {
    setTimeout(() => setLoader(true), 1000)
    if (type == 'edit' && stepIndex == 3 && !isExpand) {
      try {
        const wrapper = document.getElementsByTagName("section")[2].children[1].children[0].children[0].children[0].children[0]
        if (wrapper) wrapper.click()
      }
      catch (err) { }

      setIsExpand(true)
    }
  }, [])

  return (
    <div>
      {loader &&
        <React.Fragment>
          {type == 'edit' && <EditClientStep cookie={{ run, stepIndex, tourCompleted, type }}
            isExpand={isExpand} setIsExpand={setIsExpand} setTutorialStep1={setTutorialStep1} />
          }
          {type == 'show' && <ShowClientStep cookie={{ run, stepIndex, tourCompleted, type }}
            setTutorialStep1={setTutorialStep1} />
          }
          {type == 'next' && tourCompleted && <NextStep setTutorialStep1={setTutorialStep1} setTutorialStep2={setTutorialStep2} />}
        </React.Fragment>
      }
    </div>
  )
}
